import script from "./ControlInventarioView.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlInventarioView.vue?vue&type=script&setup=true&lang=js"

import "./ControlInventarioView.vue?vue&type=style&index=0&id=ed70dfa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed70dfa2"]])

export default __exports__